import { Clock, Wifi, IdCard, Activity } from "lucide-react";
import { type InstalledApp } from "@/hooks/useDevices";
import { AppleDeviceIcon } from "@/components/icons";

interface DeviceCardInfoProps {
  os: string;
  osType: string;
  deviceName: string;
  lastSeen: string;
  ip: string;
  serialNumber: string | null;
  batteryLevel?: number | null;
  batteryStatus?: string | null;
  installedApps: InstalledApp[];
}

const DeviceCardInfo = ({
  os,
  osType,
  deviceName,
  lastSeen,
  ip,
  serialNumber,
  batteryLevel,
  batteryStatus,
  installedApps,
}: DeviceCardInfoProps) => {
  return (
    <div className="space-y-3 text-left">
      <div className="flex items-center text-sm text-slate-500 dark:text-slate-400">
        <AppleDeviceIcon 
          osType={osType}
          modelName={deviceName}
          className="h-4 w-4 mr-2"
        />
        <span>{os}</span>
      </div>
      <div className="flex items-center text-sm text-slate-500 dark:text-slate-400">
        <Clock className="h-4 w-4 mr-2" />
        <span>Last seen: {new Date(lastSeen).toLocaleString()}</span>
      </div>
      <div className="flex items-center text-sm text-slate-500 dark:text-slate-400">
        <Wifi className="h-4 w-4 mr-2" />
        <span>IP: {ip || 'Not Available'}</span>
      </div>
      <div className="flex items-center text-sm text-slate-500 dark:text-slate-400">
        <IdCard className="h-4 w-4 mr-2" />
        <span>S/N: {serialNumber || 'Not Available'}</span>
      </div>
      {batteryLevel !== undefined && (
        <div className="flex items-center text-sm text-slate-500 dark:text-slate-400">
          <Activity className="h-4 w-4 mr-2" />
          <span>
            Battery: {batteryLevel}% ({batteryStatus || 'Unknown'})
          </span>
        </div>
      )}
      <div className="text-sm text-slate-500 dark:text-slate-400">
        <span className="font-medium">Installed Apps: </span>
        <span>{Array.isArray(installedApps) ? installedApps.length : 0}</span>
      </div>
    </div>
  );
};

export default DeviceCardInfo;